import { Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface StopLocalTrackInteractorProps {
  room: Room;
  type: "audio" | "video";
}

export class StopLocalTrackInteractor extends SyncInteractor<
  StopLocalTrackInteractorProps,
  void
> {
  public execute(props: StopLocalTrackInteractorProps): void {
    const stream = props.room.localParticipant?.stream || null;
    if (!stream) return;
    stream.stop(props.type);
  }

  public static create(): StopLocalTrackInteractor {
    return new StopLocalTrackInteractor();
  }
}
